import React from "react"
import { Button, Modal, Form, Col, InputGroup, Row, Spinner } from "react-bootstrap"
import { toast } from "react-toastify"
import { Subscription } from "rxjs"
import ActionButton from "../ActionButton"
import GlobalParameterData from "../../api/Administration/Model/GlobalParameterData"
import {GetGlobalParameter, GlobalParameterUpdate} from "../../api/Administration/GlobalParameter"
import ParameterTypeData from "../../api/Administration/Model/ParameterTypeData"
import {GetParameterTypes} from "../../api/Administration/ParameterType"
import { RouteComponentProps } from "react-router"
import { Home } from "../../config/Routes"
import { AppState } from "../../AppState"
import { connect } from "react-redux"
import ParameterTypeModal from "./ParameterTypeModal"
import {getLoggedInUserName } from "../../authentication/SelectedCompany/CompanySelectionDrivenSelectors"
import { AppPageWrapper } from "../NavMenu/AppPageWrapper"

interface GlobalParameterProps {
  LoginName: string
}

interface GlobalParameterState {
  parameterID: number
  parameterTitle: string
  parameterDescription: string
  parameterType: string
  parameterValue: string
  createdBy: string
  modifiedBy: string
  isTitleValid: boolean
  isDescriptionValid: boolean
  isTypeValid:boolean
  isValueValid:boolean
  dataLoading:boolean
  dataSaving:boolean
  parameterTypesLoading:boolean
  parameterTypes: ParameterTypeData[]
  selectedItem?: GlobalParameterData
  showAddParameterType:boolean
  parameterTypesSubmitted:number

}


export class GlobalParameter extends React.Component<GlobalParameterProps & RouteComponentProps, GlobalParameterState> {
  
  emptyState: GlobalParameterState = {
    parameterID:0,
    parameterTitle: "",
    parameterDescription: "",
    parameterType: "",
    parameterValue: "",
    createdBy: "",
    modifiedBy: "",
    isTitleValid: false,
    isDescriptionValid: false,
    isTypeValid:false,
    isValueValid:false,
    dataLoading:false,
    dataSaving:false,
    parameterTypesLoading:false,
    parameterTypes:[],
    selectedItem: undefined,
    showAddParameterType: false,
    parameterTypesSubmitted:0
  }
  
  state: GlobalParameterState = { ...this.emptyState }

  saveSubscription?: Subscription
  loadSubscription?: Subscription
  loadParameterTypeSubscription?: Subscription

  componentDidMount() {
    this.setState({ parameterTypesLoading: true, parameterTypes:[], selectedItem: undefined })

    this.loadParameterTypeSubscription = GetParameterTypes().subscribe(
      (parameterTypes: ParameterTypeData[]) => {
        this.setState({ 
          parameterTypes: parameterTypes,
          parameterTypesLoading: false 
        })
      },
      (error) => {
        toast.error(error?.errorData?.message || error.message)
        this.setState({ parameterTypesLoading: false, parameterTypes:[]})
      },
      () => {
        this.setState({ parameterTypesLoading: false })
      }
    )

  }

  componentWillUnmount() {
    this.saveSubscription && this.saveSubscription.unsubscribe()
    this.loadSubscription && this.loadSubscription.unsubscribe()
    this.loadParameterTypeSubscription && this.loadParameterTypeSubscription.unsubscribe()
  }
  handleExit = () => {
    (this.props as RouteComponentProps).history?.push(Home)
  }
  handleCancel = () => {
    this.clearData()
  }
  handleSubmit = () => {
    this.setState({ dataSaving: true })
    const updateData = this.stateToData()
    this.saveSubscription && this.saveSubscription.unsubscribe()
    this.saveSubscription = GlobalParameterUpdate(updateData).subscribe(
      data => {
        this.setState({ dataSaving: false })
        toast.success(data)
      },
      (error) => {
        toast.error(error?.errorData?.message || error.message)
        this.setState({ dataSaving: false })
      },
      () => {
        this.setState({ dataSaving: false })
      }
    )

  }

  handleTitleChange = ( value: string) => {
    this.setState(
      { 
        parameterTitle: value, 
        isTitleValid: this.isTitleValid(value) 
    }) 
  }

  handleDescriptionChange = ( value: string) => {
    this.setState(
      { 
        parameterDescription:value, 
        isDescriptionValid: this.isDescriptionValid(value)  
      })
  }
  handleValueChange = ( value: string) => {
    this.setState(
      { 
        parameterValue:value,
        isValueValid: this.isValueValid(value)  

      })
  }
  handleParameterTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const pt = this.state.parameterTypes.find(item => item.ParameterType === String(e.target.value))
    const value = pt?.ParameterType || ""
    this.setState(
      { 
        parameterType: value,
        isTypeValid : this.isParameterTypeValid(value)
    })
  }
  handleRetrieve = () => {
    this.setState({ dataLoading: true, selectedItem: undefined })
    const { parameterTitle} = this.state

      this.loadSubscription = GetGlobalParameter(parameterTitle).subscribe(
        (data: GlobalParameterData) => {
          this.setState({ 
            selectedItem: data,
            parameterID: data.ParameterID,
            parameterTitle:  data.ParameterTitle,
            parameterDescription:  data.ParameterDescription,
            parameterType:  data.ParameterType,
            parameterValue:  data.ParameterValue,
            isTitleValid:  this.isValueValid(data.ParameterTitle),
            isDescriptionValid:  this.isDescriptionValid(data.ParameterDescription),
            isTypeValid: this.isParameterTypeValid(data.ParameterType),
            isValueValid: this.isValueValid(data.ParameterValue),
            dataLoading: false 
          })
        },
        (error) => {
          toast.error(error?.errorData?.message || error.message)
          this.setState({ dataLoading: false })
        },
        () => {
          this.setState({ dataLoading: false })
        }
      )
  }
  handleAddParameterType = () => {
    this.setState(
      {
        showAddParameterType:true,
        parameterTypesSubmitted:0
      })
  }
  isTitleValid = (value: string) => {
    if (value.length < 1) {
      return false
    }
    return true;
  }
  isDescriptionValid = (value: string) => {
    if (value.length < 1) {
      return false
    }
    return true;
  }
  isParameterTypeValid = (value: string) => {
    if (value.length < 1) {
      return false
    }
    return true;
  }
  isValueValid = (value: string) => {
    if (value.length < 1) {
      return false
    }
    return true;
  }
  clearData= () => {
    const value = ""
    this.setState({ 
      selectedItem: undefined,
      parameterID: 0,
      parameterTitle:  value,
      parameterDescription:  value,
      parameterType:  value,
      parameterValue:  value,
      isTitleValid:  this.isValueValid(value),
      isDescriptionValid:  this.isDescriptionValid(value),
      isTypeValid: this.isParameterTypeValid(value),
      isValueValid: this.isValueValid(value)
    })
  }
  addParameterType = (parameterType: string, parameterTypeDescription: string) => {
    const parameterTypesSubmitted = this.state.parameterTypesSubmitted;
    this.setState({parameterTypesSubmitted:parameterTypesSubmitted+1})
  }
  closeParameterType = () => {
    this.setState({showAddParameterType: false})
    if(this.state.parameterTypesSubmitted > 0){
      this.loadParameterTypes();
    }
    this.setState({parameterTypesSubmitted:0})
  }
  loadParameterTypes() {
    this.loadParameterTypeSubscription && this.loadParameterTypeSubscription.unsubscribe()
    this.setState({ parameterTypesLoading: true, parameterTypes:[], selectedItem: undefined })

    this.loadParameterTypeSubscription = GetParameterTypes().subscribe(
      (parameterTypes: ParameterTypeData[]) => {
        this.setState({ 
          parameterTypes: parameterTypes,
          parameterTypesLoading: false 
        })
      },
      (error) => {
        toast.error(error?.errorData?.message || error.message)
        this.setState({ parameterTypesLoading: false, parameterTypes:[]})
      },
      () => {
        this.setState({ parameterTypesLoading: false })
      }
    )

  }

  render() {
    const {parameterID, parameterTitle,parameterDescription, parameterType, parameterValue, 
      isTitleValid, isDescriptionValid, isTypeValid, isValueValid, 
      dataLoading, dataSaving, parameterTypesLoading, 
      parameterTypes, selectedItem, showAddParameterType, parameterTypesSubmitted} = this.state;
      const isDataValid = isTitleValid && isDescriptionValid && isTypeValid && isValueValid
      const isLoadingOrSaving = dataLoading || dataSaving || parameterTypesLoading

    return (
      <AppPageWrapper showNav>
      <Modal.Dialog size="xl">
        <Modal.Header>
          <Modal.Title className="text-uppercase">Add / Edit Global Parameters</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
          {parameterTypesLoading && <Row><Col className="text-center"><Spinner animation="border" variant="secondary" /></Col></Row>}
            <Form.Row className="form-group required">
              <Form.Label column lg={2} htmlFor="parameterTitle">Title</Form.Label>
              <Col lg={7}>
                  <Form.Control 
                  id="parameterTitle" 
                  className="bg-white" 
                  type="text" 
                  maxLength={50}
                  value={this.state.parameterTitle} 
                  onChange={e => this.handleTitleChange(e.target.value)}
                  disabled={isLoadingOrSaving}
                  />
              </Col>
              <Col lg={2}>
                <ActionButton 
                variant="secondary" onClick={this.handleRetrieve} 
                disabled={isLoadingOrSaving || !this.state.isTitleValid} spin={dataLoading} disableOnSpin>Retrieve</ActionButton>
              </Col>
            </Form.Row>
          <Form.Row className="form-group required">
              <Form.Label column lg={2} htmlFor="parameterDescription">Description</Form.Label>
              <Col lg={7}>
                  <Form.Control 
                  id="parameterDescription" 
                  className="bg-white"  
                  as="textarea" 
                  rows={3} 
                  maxLength={255}
                  value={this.state.parameterDescription} 
                  onChange={e => this.handleDescriptionChange(e.target.value)}
                  disabled={isLoadingOrSaving}
                  />
              </Col>
              <Col lg={2}>
              </Col>
            </Form.Row>
            <Form.Row className="form-group required">
                <Form.Label column lg={2} htmlFor="parameterType">Type</Form.Label>
                <Col lg={7}>
                  <Form.Control 
                  id="parameterType" as="select" 
                  value={parameterType.toString()} 
                  onChange={this.handleParameterTypeChange}
                  disabled={isLoadingOrSaving}
                  >
                    <option value="">Select Parameter Type</option>
                    {parameterTypes && parameterTypes.map((pt: ParameterTypeData) => <option value={pt.ParameterType} key={pt.ParameterType}>{pt.ParameterTypeDescription}</option>)}
                  </Form.Control>
                </Col>
                <Col lg={2} >
                  <Button variant="secondary" 
                  onClick={this.handleAddParameterType}
                  disabled={isLoadingOrSaving}>Add New</Button>
                </Col>
              </Form.Row>
            <Form.Row className="form-group required">
              <Form.Label column lg={2} htmlFor="parameterValue">Value</Form.Label>
              <Col lg={7}>
                  <Form.Control 
                  id="parameterValue" 
                  className="bg-white"  
                  type="textarea" 
                  maxLength={255}
                  value={this.state.parameterValue} 
                  onChange={e => this.handleValueChange(e.target.value)}
                  disabled={isLoadingOrSaving}
                  />
              </Col>
              <Col lg={2} >
              </Col>
            </Form.Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleExit} disabled={isLoadingOrSaving}>Exit</Button>
          <ActionButton 
            variant="primary" 
            onClick={this.handleSubmit}
            disabled={isLoadingOrSaving || !isDataValid} spin={dataSaving} disableOnSpin>Submit</ActionButton>
          <Button variant="secondary" onClick={this.handleCancel} disabled={isLoadingOrSaving}>Cancel</Button>
        </Modal.Footer>
      </Modal.Dialog>

{showAddParameterType && <ParameterTypeModal 
    show={showAddParameterType} 
    onCancel={() => this.closeParameterType()}
    onSubmit={(parameterType: string, parameterTypeDescription: string) => this.addParameterType(parameterType, parameterTypeDescription)}
    LoginName={this.props.LoginName} />}
</AppPageWrapper>
    )
  }

  stateToData():GlobalParameterData {
    return {
      ParameterID: this.state.parameterID,
      ParameterTitle: this.state.parameterTitle,
      ParameterDescription: this.state.parameterDescription,
      ParameterType: this.state.parameterType,
      ParameterValue: this.state.parameterValue,
      CreatedBy: "",
      ModifiedBy: ""
    }
  }
}

function mapStateToProps(state: AppState): GlobalParameterProps {
  return {
    LoginName: getLoggedInUserName(state),
  }
}


const ConnectedGlobalParameter = connect(mapStateToProps, null)(GlobalParameter)
export default ConnectedGlobalParameter
